import { optionType } from "@/propTypes";
import { Button, Form, Input } from "antd";
import { arrayOf } from "prop-types";
import { useIntl } from "react-intl";

import { EntityStatus, FormType, ValueType } from "@/enums";
import { useNewFormFieldContext } from "../NewFormFieldProvider";
import { OptionUserValue } from "./OptionUserValue";
import { OptionValue } from "./OptionValue";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormFieldContainer } from "./styled";

export const OptionsFormField = ({ availableDependantValues }) => {
  const intl = useIntl();
  const { formRef } = useNewFormFieldContext();
  const statusFormTypes = [FormType.Intake.toLowerCase()];

  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="placeholder"
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="requiredValidationText"
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <div className="ant-form-item-label">
        <label>{intl.formatMessage({ id: "newFormField.options" })}</label>
      </div>
      <Form.List name="options">
        {(fields, { add, remove }) => (
          <div>
            {fields.map((field) => {
              const valueType = formRef.current.getFieldValue([
                "options",
                field.key,
                "valueType",
              ]);

              if (valueType === ValueType.FormPropertyUserValue) {
                return (
                  <OptionUserValue
                    field={field}
                    remove={remove}
                    availableDependantValues={availableDependantValues}
                    key={field.key}
                  />
                );
              }
              return (
                <OptionValue
                  field={field}
                  remove={remove}
                  availableDependantValues={availableDependantValues}
                  key={field.key}
                />
              );
            })}

            {formRef?.current &&
              formRef.current.getFieldValue("Name") === "Status" &&
              statusFormTypes.includes(
                formRef.current.getFieldValue("formType")
              ) && (
                // only admins creating form field 'status' will see this message
                <div>
                  {intl.formatMessage({
                    id: "newFormField.statusOptionsMessage",
                  })}
                </div>
              )}

            <Form.Item>
              <Button
                data-test-id={`option-form-field-new-form-field-add-option`}
                type="dashed"
                onClick={() => {
                  add({
                    ValueType: ValueType.FormPropertyValue,
                    Status: EntityStatus.Active,
                  });
                }}
                block
                icon={<FontAwesomeIcon icon={faPlusCircle} />}
              >
                {intl.formatMessage({ id: "newFormField.addOption" })}
              </Button>

              <Button
                data-test-id={`option-form-field-new-form-field-add-user`}
                type="dashed"
                onClick={() => {
                  add({
                    ValueType: ValueType.FormPropertyUserValue,
                    Status: EntityStatus.Active,
                  });
                }}
                block
                icon={<FontAwesomeIcon icon={faPlusCircle} />}
              >
                {intl.formatMessage({ id: "newFormField.addUser" })}
              </Button>
            </Form.Item>
          </div>
        )}
      </Form.List>
    </FormFieldContainer>
  );
};

OptionsFormField.propTypes = {
  availableDependantValues: arrayOf(optionType).isRequired,
};
